module.exports = __webpack_public_path__ + "static/media/monster.2d329e53.png";